import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import queryString from 'query-string';
import kredivoIcon from '../../images/kredivo-icon.png';
import kredivoDeclined from '../../images/kredivo-payment-declined.png';
import SuccessIcon from '../../images/kick-credit-payment-success.jpg';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import {
  Container,
  Row,
  Col,
  Card,
  CardText,
  Button
} from 'reactstrap';

const NOT_FOUND = '/404';
const HOME_ROUTE = '/';
export default class PagePaymentKredivo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...queryString.parse(props.location.search),
      messageText: '',
      success: false,
      headerText: ''
    }
    this._handleGoHome = this._handleGoHome.bind(this);
  }
  componentDidMount() {
    const { tr_id, tr_status, order_id, sign_key } = this.state;
    if (!(tr_id && tr_status && order_id && sign_key)) {
      this.props.history.replace(NOT_FOUND);
    }
    else
      this._validateResponse();
  }

  _validateResponse() {
    switch (this.state.tr_status) {
      case "cancel":
        this.setState({
          messageText: `Pembayaran anda telah dibatalkan oleh kredivo. 
        Harap hubungi customer service kredivo. 
        Order (${this.state.order_id}) Anda tidak bisa kami proses. Terima kasih.`, headerText: 'Payment is declined.'
        });
        break;
      case "deny":
        this.setState({
          messageText: `Pembayaran anda telah tolak oleh kredivo. 
        Harap hubungi customer service kredivo. 
        Order (${this.state.order_id}) Anda tidak bisa kami proses. Terima kasih.`, headerText: 'Payment is declined.'
        });
        break;
      case "settlement":
        this.setState({
          messageText: `Pembayaran anda telah berhasil. 
        Terima kasih telah melakukan pembayaran melalui kredivo. 
        Order (${this.state.order_id}) Anda akan segera kami proses.`, success: true, headerText: 'Pembayaran Berhasil'
        });
        break;
    }
  }
  _handleGoHome(e) {
    // e.preventDefault();
    this.props.history.push(HOME_ROUTE);
  }

  render() {
    return (
      <>
        {/* <Container
          className="main-container page-container"
        >
          <Row>
            <Col xs={12} md={{ size: 6, offset: 3 }}>
              <Card body style={{ border: 'none' }}>
                <h3 className="text-center">{this.state.headerText}</h3>
                <KickImage src={kredivoIcon} alt="Buy Now, Pay Later with Kredivo" width={100} style={{ margin: '20px auto' }} />

                <h5 className="text-center">{this.state.order_id}</h5>
                <CardText className="text-center" style={{ marginTop: 15 }}>
                  <i className={classNames("fa", { "fa-check": this.state.success, "fa-times": !this.state.success })} style={{ fontSize: 150 }}></i>
                  <br />
                  <span style={{ textAlign: 'left', display: 'block' }}>{this.state.messageText}</span>
                </CardText>
                {this.state.message && (
                  <CardText>
                    referenceId: {this.state.tr_id}
                    <br />
                    reason: {this.state.message}
                  </CardText>
                )}
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 15 }}>
                  <Button onClick={this._handleGoHome} className="btn-green bold">Kembali Berbelanja</Button>
                </div>
              </Card>
            </Col>
          </Row>
        </Container> */}

        <div id="kredivo-payment-result">
          <div className="kredivo-payment-result-wrapper">
            <div className="icon-wrapper">
              <KickImage src={this.state.success ? SuccessIcon : kredivoDeclined} alt="Buy Now, Pay Later with Kredivo" width={100} style={{ margin: '20px auto' }} />
            </div>
            <div className="header-text-wrapper">
              <p>{this.state.headerText}</p>
            </div>
            <div className="message-text-wrapper">
              <p>{this.state.messageText}</p>
            </div>
            {this.state.message && (
              <div className="referenceId-wrapper">
                <p>referenceId: {this.state.tr_id}</p>
                <p>reason: {this.state.message}</p>
              </div>
            )}
            <div className="button-wrapper">
              <div className="back-to-shopping-btn" onClick={() => this._handleGoHome()}><p>Kembali Berbelanja</p></div>
            </div>
          </div>
        </div>
      </>
    )
  }
}